export default "__VITE_ASSET__D51BLTcs__"